var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-app',{attrs:{"light":"","fill-height":""}},[_c('x-content',{attrs:{"fill-height":""}},[_c(_vm.layout,{tag:"transition-group",staticClass:"fill-height",class:_vm.layout,attrs:{"id":"wrapper","name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"info":_vm.info,"notifications":_vm.notifications}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }